import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type UserPatternTransactionFragment = { id: string, date: any, descriptionText: string, patternType: string, patternsCount: number, transactionType: Types.TransactionTypeEnum, order: { id: string, token: string, pubId: string } | null };

export const UserPatternTransactionFragmentDoc = gql`
    fragment UserPatternTransactionFragment on UserPatternTransactionType {
  id
  date
  descriptionText
  patternType
  patternsCount
  transactionType
  order {
    id
    token
    pubId
  }
}
    `;